import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('brand/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('brand/list', val_params);
  }

  get(val_id: number) {
    return this.restService.get('brand/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('brand/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('brand/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('brand/delete', val_id);
  }
}
